import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SgzpMasterChangePasswordSentComponent } from './sgzp-master-change-password-sent/sgzp-master-change-password-sent.component';
import { SgzpMasterForgotPasswordComponent } from './sgzp-master-forgot-password/sgzp-master-forgot-password.component';
import { SgzpMasterInputComponent } from './sgzp-master-input/sgzp-master-input.component';
import { SgzpMasterLoginComponent } from './sgzp-master-login/sgzp-master-login.component';
import { SgzpMasterPasswordInputComponent } from './sgzp-master-password-input/sgzp-master-password-input.component';
import { SgzpMasterRegisterResendComponent } from './sgzp-master-register-resend/sgzp-master-register-resend.component';
import { SgzpMasterRegisterSendComponent } from './sgzp-master-register-send/sgzp-master-register-send.component';
import { SgzpMasterRegisterComponent } from './sgzp-master-register/sgzp-master-register.component';
import { SgzpMasterResetPasswordComponent } from './sgzp-master-reset-password/sgzp-master-reset-password.component';
import { SgzpMasterUnblockComponent } from './sgzp-master-unblock/sgzp-master-unblock.component';
import { SgzpMasterComponent } from './sgzp-master/sgzp-master.component';

@NgModule({
  declarations: [
    SgzpMasterComponent,
    SgzpMasterLoginComponent,
    SgzpMasterRegisterComponent,
    SgzpMasterUnblockComponent,
    SgzpMasterRegisterResendComponent,
    SgzpMasterRegisterSendComponent,
    SgzpMasterForgotPasswordComponent,
    SgzpMasterResetPasswordComponent,
    SgzpMasterChangePasswordSentComponent,
    SgzpMasterInputComponent,
    SgzpMasterPasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SgzpMasterResetPasswordComponent,
    SgzpMasterComponent,
    SgzpMasterRegisterResendComponent,
    SgzpMasterRegisterSendComponent,
    SgzpMasterUnblockComponent,
    SgzpMasterChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SgzpMasterModule { }
